import { createTheme } from '@mui/material/styles';
import './theme-types.d.ts';

// Mapped figma fonts to actual font names
// font-family-head -> SparkasseHeadWeb
// font-family-medium -> SparkasseWebMedium
// font-family-lt -> SparkasseWebLight
// font-family-rg -> SparkasseWeb

const sparkasseFont = 'SparkasseWeb, Helvetica, Arial, sans-serif';
export const sparkasseMediumFont = 'SparkasseWebMedium, SparkasseWeb, Helvetica, Arial, sans-serif';
// not used currently
// const sparkasseLightFont = 'SparkasseWebLight, SparkasseWeb, Helvetica, Arial, sans-serif';
export const sparkasseHeadFont = 'SparkasseHeadWeb, SparkasseWeb, Helvetica, Arial, sans-serif';

export const theme = createTheme({
  components: {
    MuiStack: {
      defaultProps: {
        spacing: 0,
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          lineHeight: '25px',
          color: '#000000',
          marginBottom: '6px',
          '&.Mui-disabled': {
            color: '#000000',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#ffffff',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
        },
      },
    },
    MuiPickersTextField: {
      styleOverrides: {
        root: {
          width: '100%',
          marginTop: '0 !important',
          '& .MuiPickersSectionList-root': {
            padding: '16.5px 14px 16.5px 0',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'white',
          color: '#444',
          border: '1px solid #ccc',
          fontSize: '16px',
          lineHeight: '25px',
          padding: '1rem',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: '#E3E3E3',
            '& fieldset': {
              height: 'auto',
            },
          },
        },
        input: {
          '&.Mui-disabled': {
            color: '#969696',
            WebkitTextFillColor: '#969696',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: sparkasseFont,

    h1: {
      color: '#000',
      fontFamily: sparkasseHeadFont,
      fontWeight: 700,
      fontSize: '28px',
      lineHeight: '31px',
    },
    h2: {
      color: '#000',
      fontFamily: sparkasseHeadFont,
      fontWeight: 700,
      fontSize: '22px',
      lineHeight: '25px',
    },
    h3: {
      fontFamily: sparkasseHeadFont,
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '24px',
    },

    body1: {
      fontFamily: sparkasseFont,
      fontSize: '16px',
      lineHeight: '25px',
      fontWeight: 400,
      color: '#444',
    },
  },
});
